import { Controller } from "@hotwired/stimulus"
import TurboLight from "turbolight";

// Connects to data-controller="turbo-light"
export default class extends Controller {
  connect() {
    this.turboLight = new TurboLight();
  }

  disconnect() {
    if (this.turboLight && this.turboLight.isOpen) {
      this.turboLight.close();
    }
  }
}
